import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-divider',
    templateUrl: './divider.component.html',
    styleUrls: ['./divider.component.scss'],
    imports: [CommonModule]
})
export class DividerComponent {
  @Input() text?: string;
  @Input() margin?: string = '15px 0';
  @Input() height?: string = '1px';
}
